import * as React from "react";
import * as ReactDOM from "react-dom";
import * as $ from "jquery";
import { MainMenuComponent, IMenu, MenuItem } from "./MainMenu";
import { InvestigatorSelectorComponent } from "./InvestigatorSelector";
import { ICard, CardType, TokenUtil, GameToken, ApplicationException, CardSubType } from "./Card";
import { SummaryScreenComponent } from "./SummaryScreen";
import { ThemeTextComponent } from "./ThemeText";
import { ScenarioPlayComponent } from "./ScenarioPlayComponent";
import { Stock } from "./Stock";
import {
    GameDifficulty, IScenarioState, IInvestigatorInPlay, PlayerComponent, ScenarioState, ILocation, IThemeText,
    ThemeTextUtil,
    ScenarioType
} from "./Scenario";
import { NightOfTheZealot } from "./Campaign-NightOfTheZealot";
import { Version } from "./Version";
import { CampaignLogComponent } from "./CampaignLogComponent";
import { ScenarioSummaryComponent } from "./ScenarioSummaryComponent";
import { AudioPlayer } from "./AudioPlayer";
import { LocalStorageUtil } from "./LocalStorageUtil";
import { AudioPlayerComponent } from "./AudioPlayerComponent";
import { VictoryDisplayComponent } from "./VictoryDisplayComponent";
import { InvestigatorUtil } from "./InvestigatorUtil";
import { Game } from "./Game";
import { GameStage } from "./GameStage";
import { SaveGameComponent } from "./SaveGameComponent";
import { LoadGameComponent } from "./LoadGameComponent";
import { TheDunwichLegacy } from "./Campaign-TheDunwichLegacy";
import { DeckUtil } from "./DeckUtil";
import { CardUtil } from "./CardUtil";
import { AppUtil } from "./AppUtil";
import { PlayMatUtil } from "./PlayMatUtil";


export interface IError {
    error: Error;
    info: Object;
}

export interface IAppState {
    version: string;
    error?: IError;
    stage: GameStage;
    numberOfPlayers?: number;
    //investigators?: IInvestigator[];
    scenarioState?: IScenarioState;
    showSaveGame?: boolean;
}

class DefaultState implements IAppState {
    version = Version.toString();
    error: IError = null;
    stage: GameStage = GameStage.MainMenu;
}

class UserSettings {
    musicVolume: number = 0.3;
    musicPaused: boolean = false;
}
interface IArkhamHorrorTcgExpansions {
    theDunwichLegacy: boolean;
}
export interface IAppProps {
    expansions: IArkhamHorrorTcgExpansions;
    cardAspectRatio?: number;
}

export class App extends React.Component<IAppProps, IAppState> {
    constructor(props: IAppProps) {
        super(props);

        Stock.registerModule(new NightOfTheZealot());
        if (props.expansions.theDunwichLegacy) {
            Stock.registerModule(new TheDunwichLegacy());
        }
        if (props.cardAspectRatio) {
            AppUtil.cardAspectRatio = props.cardAspectRatio;
        }
        let state = this.loadFromLocal();
        //if loaded state doesn't exists or if it has no stage, start with default state
        if (!state || !state.stage) {
            state = new DefaultState();
        }
        this.state = state;
        this.audioChanged = this.audioChanged.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        const userSettings = this.getUserSettings();
        AudioPlayer.volume(userSettings.musicVolume);
        if (!userSettings.musicPaused) AudioPlayer.shuffle();
    }

    audioChanged(arg: string) {
        switch (arg) {
            case "volume":
                {
                    const us = this.getUserSettings();
                    if (us.musicVolume !== AudioPlayer.volume()) {
                        us.musicVolume = AudioPlayer.volume();
                        this.saveUserSettings(us);
                    }
                    break;
                }
            case "play":
                {
                    const us = this.getUserSettings();
                    if (us.musicPaused) {
                        us.musicPaused = false;
                        this.saveUserSettings(us);
                    }
                    break;
                }
            case "pause":
                {
                    const us = this.getUserSettings();
                    if (!us.musicPaused) {
                        us.musicPaused = true;
                        this.saveUserSettings(us);
                    }
                    break;
                }
        }
        //console.log("audio player change: " + arg);
    }
    componentWillMount(): void {
        AudioPlayer.onChange(this.audioChanged);
        document.addEventListener("keydown", this.handleKeyPress, false);
    }
    logGameStat(name: string, data: any) {

        const dataObj = { name: name, data: JSON.stringify(data) };
        $.ajax("/api/gamestat",
            {
                type: "POST",
                data: JSON.stringify(dataObj),
                contentType: "application/json"

            });
    }

    componentWillUnmount(): void {
        AudioPlayer.removeOnChange(this.audioChanged);
        document.removeEventListener("keydown", this.handleKeyPress, false);
    }
    private handleKeyPress(e: any) {

        if (e.ctrlKey && e.key !== "Control") {
            switch (e.key) {
                case "s":
                    this.showSaveDialog();
                    e.preventDefault();
                    e.stopPropagation();
                    return true;
                case "q":
                    this.storeCurrentStateAsContinueGameAndResetCurrentState();
                    e.preventDefault();
                    e.stopPropagation();
                    return true;
            }
        }
        return false;
    }
    showSaveDialog() {
        this.setState({ showSaveGame: true });
    }

    private getUserSettings(): UserSettings {
        return LocalStorageUtil.loadData(App.saveSlotUserSettings, new UserSettings());
    }

    private saveUserSettings(userSettings: UserSettings): void {
        LocalStorageUtil.saveData(App.saveSlotUserSettings, userSettings);
    }
    getMenu(stage: GameStage): IMenu {

        switch (stage) {
            case GameStage.MainMenu:
                const menu = {
                    title: "",
                    items: [
                        new MenuItem("New game", () => this.setStage(GameStage.SelectCampaign)),
                        new MenuItem("Load game", () => this.setStage(GameStage.LoadGame))
                    ]
                };
                if (this.hasContinueGameStored()) {
                    menu.items.push(new MenuItem("Continue game", () => this.continueGame()));
                }
                return menu;
            case GameStage.SelectCampaign:
                const campaignItems = Stock.campaigns.map((c, i) => { return { title: c.name, action: () => this.setCampaign(i) } });
                campaignItems.push({ title: "<= Back", action: () => this.setStage(GameStage.MainMenu) });
                return {
                    title: "Select Campaign",
                    items: campaignItems
                };
            case GameStage.SelectDifficulty:
                return {
                    title: "Select difficulty",
                    items: [
                        new MenuItem("Easy", () => this.setDifficulty(GameDifficulty.Easy)),
                        new MenuItem("Standard", () => this.setDifficulty(GameDifficulty.Standard)),
                        new MenuItem("Hard", () => this.setDifficulty(GameDifficulty.Hard)),
                        new MenuItem("Expert", () => this.setDifficulty(GameDifficulty.Expert)),
                        new MenuItem("<= Back", () => this.setStage(GameStage.SelectCampaign))
                    ]
                };
            case GameStage.SelectNoOfPlayers:
                return {
                    title: "Select # players",
                    items: [
                        new MenuItem("One player", () => this.setNoOfPlayers(1)),
                        new MenuItem("Two players", () => this.setNoOfPlayers(2)),
                        new MenuItem("Three players", () => this.setNoOfPlayers(3)),
                        new MenuItem("Four players", () => this.setNoOfPlayers(4)),
                        new MenuItem("<= Back", () => this.setDifficulty(null))
                    ]
                };

            default:
                throw new ApplicationException("Stage " + stage + " has no menu defined");
        }
    }
    private static saveSlotCurrentState: string = "currentState";
    private static saveSlotContinueGame: string = "continueGame";
    private static saveSlotUserSettings: string = "userSettings";
    saveToLocal() {
        if (!LocalStorageUtil.saveData(App.saveSlotCurrentState, this.state)) {
            alert("Failed to save state to local storage.");
        }
    }
    findSubType(st: string): CardSubType {
        switch (st) {
            case "Neutral": return CardSubType.Neutral;
            case "Guardian": return CardSubType.Guardian;
            case "Rouge": return CardSubType.Rouge;
            case "Seeker": return CardSubType.Seeker;
            case "Survival": return CardSubType.Survivor;
            case "Survivor": return CardSubType.Survivor;
            case "Mystic": return CardSubType.Mystic;
            case "Weakness": return CardSubType.Weakness;
            case "Basic Weakness": return CardSubType.BasicWeakness;
        }
        return CardSubType.None;
    }
    remapCards(cards: ICard[]) {
        if (!cards || !cards.length) return;

        cards.forEach(c => {
            const cc = c as any;
            const subType = cc["subType"];
            if (typeof subType == "string") {
                c.subType = this.findSubType(subType);
            }

        });
    }
    parseJsonToAppState(data: IAppState): IAppState {
        const d = data as IAppState;
        if (d && d.scenarioState) {
            const ss = d.scenarioState;
            if (ss.actState && ss.actState.deck)
                this.remapCards(ss.actState.deck.cards);
            if (ss.agendaState && ss.actState.deck)
                this.remapCards(ss.agendaState.deck.cards);
            if (ss.discardDeck)
                this.remapCards(ss.discardDeck.cards);
            if (ss.encounterDeck)
                this.remapCards(ss.encounterDeck.cards);
            if (ss.extraDecks)
                ss.extraDecks.forEach(ed => {
                    if (ed) {
                        this.remapCards(ed.cards);
                    }
                });

            if (ss.investigators) {
                ss.investigators.forEach(inv => {
                    if (!inv) return;
                    if (inv.hand)
                        this.remapCards(inv.hand.cards);
                    if (inv.deck)
                        this.remapCards(inv.deck.cards);
                    if (inv.inPlay)
                        this.remapCards(inv.inPlay.cards);
                    if (inv.discard)
                        this.remapCards(inv.discard.cards);
                    if (inv.threat)
                        this.remapCards(inv.threat.cards);
                });
            }
        }
        return data as IAppState;
    }
    loadFromLocal(): IAppState {
        return LocalStorageUtil.loadData<IAppState>(App.saveSlotCurrentState, null, (s) => { return this.parseJsonToAppState(s); });
    }
    resetCurrentState() {
        LocalStorageUtil.remove(App.saveSlotCurrentState);
        this.setState(new DefaultState());

    }
    storeCurrentStateAsContinueGameAndResetCurrentState() {
        const data = LocalStorageUtil.loadData<IAppState>(App.saveSlotCurrentState, null, (s) => { return this.parseJsonToAppState(s); });
        LocalStorageUtil.saveData(App.saveSlotContinueGame, data);
        this.resetCurrentState();
    }
    hasContinueGameStored(): boolean {
        return !!LocalStorageUtil.loadData<IAppState>(App.saveSlotContinueGame, null, (s) => { return this.parseJsonToAppState(s); });
    }
    continueGame() {
        const state = LocalStorageUtil.loadData<IAppState>(App.saveSlotContinueGame, null, (s) => { return this.parseJsonToAppState(s); });
        this.setState(state);
    }
    setCampaign(campaignIndex: number) {
        this.setState({ scenarioState: new ScenarioState(campaignIndex), stage: GameStage.SelectDifficulty });
    }
    //if called
    setDifficulty(difficulty: GameDifficulty) {

        let stage = GameStage.SelectNoOfPlayers;
        if (!difficulty) {
            stage = GameStage.SelectDifficulty;
        }
        const ss = ({ ...this.state.scenarioState });
        ss.difficulty = difficulty;
        this.setState({ scenarioState: ss, stage: stage });
    }
    setInvestigator(card: ICard) {
        let stage = GameStage.SelectInvestigator;
        const ss = ({ ...this.state.scenarioState });
        const investigators = ss.investigators;
        let numberOfPlayers = this.state.numberOfPlayers;
        if (card) {
            if (investigators.length < numberOfPlayers) {
                const health = card.values["health"];
                const sanity = card.values["sanity"];
                const inv2: IInvestigatorInPlay = {
                    card: ({ ...card }),
                    deck: { cards: CardUtil.flip(CardUtil.shuffle(Stock.createStarterDeck(card)), false) },
                    health: health,
                    sanity: sanity,
                    mentalTrauma: 0,
                    physicalTrauma: 0,
                    activeComponent: PlayerComponent.Hand,
                    portrait: ({ ...card }),
                    experience: 0
                };
                investigators.push(inv2);
            }
            if (investigators.length === numberOfPlayers) {
                stage = GameStage.SummaryScreen;
            }
        } else {
            if (investigators.length > 0) {
                investigators.splice(investigators.length - 1, 1);
            } else { //back to select players if we back on the first player
                stage = GameStage.SelectNoOfPlayers;
                numberOfPlayers = 0;
            }
        }
        this.setState({ stage: stage, scenarioState: ss, numberOfPlayers: numberOfPlayers });
    }
    setNoOfPlayers(noOfPlayers: number) {
        const ss = ({ ...this.state.scenarioState });
        ss.investigators = [];
        this.setState({ stage: GameStage.SelectInvestigator, numberOfPlayers: noOfPlayers, scenarioState: ss });
    }

    setStage(stage: GameStage) {
        this.setState({ stage: stage });
    }

    startCampaign() {
        this.setStage(GameStage.ScenarioIntro);
    }
    startNextScenario() {
        const ss = this.state.scenarioState;
        if (!ss.scenarioSuccessful) {
            alert("Scenario failed, Game Over");
            this.setState({ stage: GameStage.MainMenu });
            return;
        }
        const campaign = Game.getCampaign(ss);
        if (ss.nextScenarioIndex !== undefined && ss.nextScenarioIndex !== null) {
            ss.scenarioIndex = ss.nextScenarioIndex;
        } else {
            ss.scenarioIndex++;
        }
        ss.nextScenarioIndex = undefined;
        ss.scenarioSetupCompleted = false;
        if (campaign.scenarios.length === ss.scenarioIndex) {
            alert("Last scenario done, campaign completed");
            this.setState({ stage: GameStage.MainMenu });
            return;
        } else {
            const scenario = Game.getScenario(ss);
            if (scenario.type === ScenarioType.Interlude) {
                this.setState({ scenarioState: ss, stage: GameStage.ScenarioIntro });
            } else {
                this.setState({ scenarioState: ss, stage: GameStage.SummaryScreen });
            }
        }
    }
    startScenario() {
        const ss = ({ ...this.state.scenarioState });
        if (!ss.scenarioSetupCompleted) {
            const scenario = Game.getScenario(ss);
            ss.roundCounter = { round: 1, phase: 1 };
            //each player draws 5 cards
            for (let i = 0; i < ss.investigators.length; i++) {
                const inv = ss.investigators[i];
                inv.resigned = false;
                //reset cards in hand
                for (let j = 0; j < inv.deck.cards.length; j++) {
                    let c = inv.deck.cards[j];
                    c.exhausted = false;
                    c.tokens = null;
                    c.faceUp = false;

                    //remove all non standard cards
                    if (!InvestigatorUtil.isPlayerCard(inv, c)) {
                        inv.deck.cards.splice(j, 1);
                        j--;
                    }

                }
                //add basic weakness card
                const randomWeakness = Stock.getRandomCardOfType(CardType.Treachery, CardSubType.BasicWeakness);
                CardUtil.flipCard(randomWeakness, false);
                inv.deck.cards.push(randomWeakness);

                CardUtil.shuffle(inv.deck.cards);

                //draw 5 cards but no treachery
                inv.hand = {
                    cards: DeckUtil.removeTopCards(inv.deck, 5, [CardType.Treachery], [CardSubType.Weakness, CardSubType.BasicWeakness])
                };
                const card = inv.card;
                //start with no tokens
                inv.card.tokens = [];
                CardUtil.shuffle(inv.deck.cards);
                const healthToken = TokenUtil.getToken(inv.card, GameToken.Health);
                healthToken.number = inv.physicalTrauma;
                healthToken.canBeMoved = true;
                healthToken.x = 233;
                healthToken.y = 203;

                const sanityToken = TokenUtil.getToken(inv.card, GameToken.Sanity);
                sanityToken.number = inv.mentalTrauma;
                sanityToken.canBeMoved = true;
                sanityToken.x = 357;
                sanityToken.y = 203;
                //add 5 resource tokens
                const token = TokenUtil.getToken(card, GameToken.Resource);
                token.number = 5;
                token.canBeMoved = true;
                token.x = 12;
                token.y = 227;
                const actionToken = TokenUtil.getToken(card, GameToken.Action);
                actionToken.number = 3;
                actionToken.canBeMoved = true;
                actionToken.x = 5;
                actionToken.y = 40;
            }
            ss.discardDeck = { cards: [] };
            ss.victoryDisplay = { cards: [] };
            scenario.setup(ss);
            ss.currentSelectedInvestigator = 0;

            //encounter deck should be facedown
            for (let i = 0; i < ss.encounterDeck.cards.length; i++) {
                ss.encounterDeck.cards[i].faceUp = false;
            }

            this.updateCluesOnLocation(ss.investigators.length, ss.locations);
            ss.scenarioSetupCompleted = true;
        }
        this.logGameStat("StartScenario", this.state);
        this.setState({ scenarioState: ss, stage: GameStage.ScenarioPlay });
    }
    updateCluesOnLocation(noOfPlayers: number, locations: ILocation[]) {
        for (let i = 0; i < locations.length; i++) {
            const loc = locations[i];
            let clues = loc.card.values["clueBase"];
            const cardMultiplier = loc.card.values["clueMultiplier"];
            if (cardMultiplier) {
                clues += cardMultiplier * noOfPlayers;
            }
            const token = TokenUtil.getToken(loc.card, GameToken.Clue);
            token.number = clues;
            token.canBeMoved = true;
            token.x = 227;
            token.y = 31;
        }
    }
    scenarioCompleted() {

        const ss = ({ ...this.state.scenarioState });
        const resolution = ss.resolution;
        ss.scenarioSuccessful = resolution.complete(ss);
        //check if any player is eligible for trauma and reset health/sanity
        for (let i = 0; i < ss.investigators.length; i++) {
            const inv = ss.investigators[i];
            inv.portrait.exhausted = false;

            //move all cards to deck
            const playerCards = DeckUtil.list(inv.discard).concat(DeckUtil.list(inv.inPlay)).concat(DeckUtil.list(inv.hand))
                .concat(DeckUtil.list(inv.deck));
            inv.hand = null;
            inv.inPlay = null;
            inv.threat = null;
            inv.discard = null;
            inv.deck = { cards: CardUtil.flip(CardUtil.shuffle(playerCards), false) };
            //make sure all cards aren't exhausted
            DeckUtil.readyExhaustedCards(inv.deck);

            //fix tokens
            let killedOrInsane = false;
            const healthToken = TokenUtil.getToken(inv.card, GameToken.Health);
            if (healthToken.number >= inv.health) {
                inv.physicalTrauma++;
            }
            if (inv.physicalTrauma >= inv.health) {
                killedOrInsane = true;
            }
            const sanityToken = TokenUtil.getToken(inv.card, GameToken.Sanity);
            if (sanityToken.number >= inv.sanity) {
                inv.mentalTrauma++;
            }
            if (inv.mentalTrauma >= inv.sanity) {
                killedOrInsane = true;
            }

            if (killedOrInsane) {
                ss.investigators.splice(i, 1);
                i--;
                if (!ss.killedAndInsaneInvestigators) {
                    ss.killedAndInsaneInvestigators = [];
                }
                ss.killedAndInsaneInvestigators.push(inv);
            }
        }

        this.logGameStat("ScenarioCompleted", this.state);
        this.setState({
            scenarioState: ss,
            stage: GameStage.ScenarioOutro
        });
    }
    gameStage(): JSX.Element {
        if (this.state.showSaveGame) {
            const ss: IAppState = {
                numberOfPlayers: this.state.numberOfPlayers,
                scenarioState: this.state.scenarioState,
                version: this.state.version,
                stage: this.state.stage
            };
            ss.showSaveGame = false;
            return (<SaveGameComponent onClose={() => { this.setState({ showSaveGame: false }) }} state={ss} />);
        }
        const stage = this.state.stage;
        let themeText: IThemeText;
        switch (stage) {
            case GameStage.MainMenu:
            case GameStage.SelectCampaign:
            case GameStage.SelectDifficulty:
            case GameStage.SelectNoOfPlayers:
                return (<MainMenuComponent menu={this.getMenu(stage)} />);
            case GameStage.LoadGame:
                return (<LoadGameComponent onLoad={(save) => {
                    if (save) {
                        let savedState = save.state;
                        savedState = this.parseJsonToAppState(savedState);
                        this.setState(savedState);
                    } else {
                        this.setStage(GameStage.MainMenu);
                    }
                }} />);
            case GameStage.SelectInvestigator:
                return (<InvestigatorSelectorComponent appState={this.state} selectInvestigator={(card) => this.setInvestigator(card)} />);
            case GameStage.SummaryScreen:
                return (<SummaryScreenComponent appState={this.state} hideBackButton={this.state.scenarioState.scenarioIndex !== 0}
                    onScenarioStateChanged={state => { this.setState({ scenarioState: state }); }}
                    onStart={(start: boolean) => {

                        if (!this.state.scenarioState.campaignSetup) {
                            if (start) {
                                this.setStage(GameStage.CampaignIntro);
                            } else {
                                this.setInvestigator(null);
                            }
                        } else {
                            if (start) {
                                this.setStage(GameStage.ScenarioIntro);
                            }
                        }
                    }} />);
            case GameStage.CampaignIntro:
                const campaign = Game.getCampaign(this.state.scenarioState);
                themeText = ThemeTextUtil.wrap(campaign.intro,
                    (appState: IAppState) => {
                        appState.stage = GameStage.ScenarioIntro;
                        appState.scenarioState.chaosBag = campaign.generateChaosBag(this.state.scenarioState.difficulty);
                        appState.scenarioState.campaignSetup = true;
                        this.setState(appState);
                    });
                return (<ThemeTextComponent appState={this.state} themeText={themeText} />);
            case GameStage.ScenarioIntro:
                const scenario = Game.getScenario(this.state.scenarioState);
                const intro = scenario.getIntro(this.state.scenarioState);

                if (scenario.type === ScenarioType.Interlude) {
                    const ss = ({ ...this.state.scenarioState });
                    ss.resolution = null;
                    intro.actions = [{
                        title: "Continue", action: () => {
                            this.setState({ scenarioState: ss, stage: GameStage.ScenarioSummary });
                        }
                    }];
                } else {
                    if (!intro.actions || !intro.actions.length) {
                        intro.actions = [{ title: "Start Scenario" }];
                    }
                    themeText = ThemeTextUtil.wrap(intro, () => { this.startScenario(); });
                }
                if (!intro.actions || !intro.actions.length) {
                    if (scenario.type === ScenarioType.Interlude) {
                        intro.actions = [{ title: "Continue" }];
                    } else {
                        intro.actions = [{ title: "Start Scenario" }];
                    }
                }
                themeText = ThemeTextUtil.wrap(intro, () => { this.startScenario(); });
                return (<ThemeTextComponent appState={this.state} themeText={themeText} />);
            case GameStage.ScenarioPlay:
                return (<ScenarioPlayComponent state={this.state}
                    onComplete={() => this.scenarioCompleted()}
                    onChanged={state => this.setState({ scenarioState: state })}
                    onExitToMainMenu={() => this.storeCurrentStateAsContinueGameAndResetCurrentState()} />);
            case GameStage.ScenarioOutro:
                themeText = this.state.scenarioState.resolution.text;
                themeText.actions = [{
                    title: "Continue",
                    action: () => {
                        this.setState({ stage: GameStage.VictoryDisplay });
                    }
                }];
                return (<ThemeTextComponent appState={this.state} themeText={themeText} />);
            case GameStage.VictoryDisplay:
                return (<VictoryDisplayComponent state={this.state} onClose={() => this.setState({ stage: GameStage.ScenarioSummary })} />);
            case GameStage.ScenarioSummary:
                return (<ScenarioSummaryComponent state={this.state.scenarioState}
                    onContinue={() => this.setState({ scenarioState: this.state.scenarioState, stage: GameStage.ShowCampaignLog })} />);
            case GameStage.ShowCampaignLog:
                return (<CampaignLogComponent state={this.state} onClose={() => this.startNextScenario()} />);
            default:
                return (<div className="error">Unknown GameStage {GameStage[stage]} </div>);
        }
    }

    componentDidCatch(error: Error, errorInfo: Object): void {
        this.setState({ error: { error: error, info: errorInfo } });
    }

    componentDidMount(): void {
        this.fixBodyClass();
    }
    fixBodyClass() {
        let campaignNo = 0;
        let scenarioNo=0;
        if(this.state.scenarioState){
            if (this.state.stage >= GameStage.CampaignIntro) {
                campaignNo = this.state.scenarioState.campaignIndex+1;
                scenarioNo = this.state.scenarioState.scenarioIndex+1;
            }
        }
        PlayMatUtil.fixBodyClass(campaignNo, scenarioNo);
    }

    componentDidUpdate(prevProps: any,
        prevState: {
            readonly [P in "stage" |
            "version" |
            "numberOfPlayers"]: IAppState[P]
        },
        snapshot?: any): void {
        this.fixBodyClass();
    }
    render() {
        let error = this.state.error;
        if (!error) {
            try {
                this.saveToLocal();
                return (
                    <div id="app">
                        {this.gameStage()}
                        <AudioPlayerComponent />
                    </div>
                );
            } catch (e) {
                error = { error: e, info: null };
            }
        }
        console.log(`Render failed\nName:${error.error.name}\nMessage:${error.error.message}\nStack:${error.error.stack}\nInfo:${JSON.stringify(error.info)}`);
        let currentStateVersion = "no current state";
        try {
            const currentState = this.loadFromLocal();
            currentStateVersion = currentState.version;
        } catch (e2) {
            console.log("Failed to load local state.\n" + e2);
        }

        return (
            <div className="container center-vertically">
                <div className="col-md-4 col-md-offset-4">
                    <div className="panel panel-warning">
                        <div className="panel-heading">
                            <h3 className="panel-title">Error</h3>
                        </div>
                        <div className="panel-body">
                            <p>Something went wrong.</p>
                            <p>Current version:{Version.toString()}</p>
                            <p>State version:{currentStateVersion}</p>
                            <pre>{error.error.message}</pre>
                            <button onClick={() => { this.resetCurrentState(); }}>Restart</button>
                        </div>
                    </div>
                </div>
            </div>
        );


    }
    static init(id: string, props: any) {
        ReactDOM.render(
            <App {...props} />,
            document.getElementById(id)
        );
    }


}
const w = window as any;
w.Ahtcg = App;